// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/

/*
  In this file, We write styles for error boundery component.
*/

.errorboundary {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #cfcfcf;
  height: 100vh;
}

.errorboundary__container {
  display: flex;
  flex-direction: column;
  padding: 1em;
  min-width: 30%;
  width: 500px;
  min-height: 40%;
  height: 70%;
  background-color: #f3f3f3;
  overflow-y: auto;
}

.errorboundary__logo {
  align-self: center;
  padding: 1rem;
}

.errorboundary__header {
  display: flex;
  font-size: 0.875rem;
  font-weight: 600;
}

.errorboundary__erroricon {
  margin-right: 0.5rem;
}

.errorboundary__header .MuiSvgIcon-root {
  color: #f56d4f;
}

.errorboundary__message {
  font-size: 0.875rem;
  font-weight: 400;
  padding: 0.8rem 0rem;
}

.errorboundary__details {
  font-weight: 600;
  border: 0px;
}

.errorboundary__summary {
  border: 1px solid grey;
  font-weight: normal;
  padding: 0.5rem;
  margin: 0.5rem 0rem;
  height: 100%;
  overflow-y: scroll;
}

.errorboundary__summary > summary {
  font-weight: 600;
}

.errorboundary__summary > p {
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/views/components/custom/errorBoundary/ErrorBoundary.css"],"names":[],"mappings":"AAAA;;;CAGC;;AAED;;CAEC;;AAED;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n\n/*\n  In this file, We write styles for error boundery component.\n*/\n\n.errorboundary {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #cfcfcf;\n  height: 100vh;\n}\n\n.errorboundary__container {\n  display: flex;\n  flex-direction: column;\n  padding: 1em;\n  min-width: 30%;\n  width: 500px;\n  min-height: 40%;\n  height: 70%;\n  background-color: #f3f3f3;\n  overflow-y: auto;\n}\n\n.errorboundary__logo {\n  align-self: center;\n  padding: 1rem;\n}\n\n.errorboundary__header {\n  display: flex;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.errorboundary__erroricon {\n  margin-right: 0.5rem;\n}\n\n.errorboundary__header .MuiSvgIcon-root {\n  color: #f56d4f;\n}\n\n.errorboundary__message {\n  font-size: 0.875rem;\n  font-weight: 400;\n  padding: 0.8rem 0rem;\n}\n\n.errorboundary__details {\n  font-weight: 600;\n  border: 0px;\n}\n\n.errorboundary__summary {\n  border: 1px solid grey;\n  font-weight: normal;\n  padding: 0.5rem;\n  margin: 0.5rem 0rem;\n  height: 100%;\n  overflow-y: scroll;\n}\n\n.errorboundary__summary > summary {\n  font-weight: 600;\n}\n\n.errorboundary__summary > p {\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
